import React from 'react';
import { Link } from "react-router-dom";
import './Card.css';

export const Web = () => {
  const data = [
    {
      id: "01",
      link: "https://dluongta.github.io/",
      linkName: "General Intoduce Page",
    },
    {
      id: "02",
      link: "https://the-digital-shop.onrender.com",
      linkName: "The Shop",
    },
    {
      id: "03",
      link: "https://github.com/luen2003/python-code",
      linkName: "Python Code",
    },
    {
      id: "04",
      link: "https://dluongta.github.io/qr-scanner.html",
      linkName: "QRCode Scanner",
    },
    {
      id: "05",
      link: "https://react-app-videocall.onrender.com/",
      linkName: "Voice Or Video Call Using WebRTC",
    },
    {
      id: "06",
      link: "https://dluongta.github.io/qr-generator.html",
      linkName: "QRCode Generator",
    },
    {
      id: "07",
      link: "https://react-app-google-login-page.vercel.app/",
      linkName: "React App Google Login Page",
    },
    {
      id: "08",
      link: "https://dluongta.github.io/pdf-excel-generator.html",
      linkName: "PDF And Excel Generator",
    },
    {
      id: "09",
      link: "https://react-livestream-app.onrender.com/",
      linkName: "React Livestream App",
    },
    {
      id: "10",
      link: "https://dluongta.github.io/text_speech.html",
      linkName: "Text Speech",
    },
    {
      id: "11",
      link: "https://dluongta.github.io/quiz-app.html",
      linkName: "Quiz App",
    },
    {
      id: "12",
      link: "https://dluongta.github.io/digital-calendar.html",
      linkName: "Digital Calendar",
    },
    {
      id: "13",
      link: "https://dluongta.github.io/caculator.html",
      linkName: "Caculator",
    },
    {
      id: "14",
      link: "https://github.com/luen2003/ASPNET_API",
      linkName: "ASPNET API",
    },
    {
      id: "15",
      link: "https://shootingtankio.onrender.com/",
      linkName: "Shooting Tank IO",
    },
    {
      id: "16",
      link: "https://dluongta.github.io/image_editor/index.html",
      linkName: "Image Editor",
    },
    {
      id: "17",
      link: "https://dluongta.github.io/upload_avatar.html",
      linkName: "Upload Avatar",
    },
    {
      id: "18",
      link: "https://react-app-bank-code.vercel.app/",
      linkName: "Confirm Payment",
    },
    {
      id: "19",
      link: "https://github.com/luen2003/mysql-api",
      linkName: "NodeJS MySQL API",
    },
    {
      id: "20",
      link: "https://github.com/luen2003/php-mysql-api",
      linkName: "PHP MySQL API",
    },
    {
      id: "21",
      link: "https://dluongta.github.io/flipbook3d.html",
      linkName: "3D Flip Book",
    },
    {
      id: "22",
      link: "https://dluongta.github.io/text_image.html",
      linkName: "Text Image",
    },
    {
      id: "23",
      link: "https://dluongta.github.io/voice_recording.html",
      linkName: "Voice Recording",
    },
    {
      id: "24",
      link: "https://dluongta.github.io/video_recording.html",
      linkName: "Video Recording",
    },
    {
      id: "25",
      link: "https://dluongta.github.io/spin_wheel.html",
      linkName: "Spin Wheel",
    },
    {
      id: "26",
      link: "https://dluongta.github.io/vn-telex-input.html",
      linkName: "VN Telex Input",
    },
    {
      id: "27",
      link: "https://dluongta.github.io/image-framer-studio.html",
      linkName: "Image Framer Studio",
    },
    {
      id: "28",
      link: "https://dluongta.github.io/web_preview.html",
      linkName: "Web Preview",
    }
  ];

  return (
    <>
      <section className='pages'>
        <div className="cards-wrapper">
          {data.map((value) => {
            return (
              <div key={value.id} className="basic-card card">
                <div className="card-content">
                  <h1>{value.linkName}</h1>
                </div>
                <a
                  className="link"
                  href={value.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  &rarr; {value.link}
                </a>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};